import { ArenaGameState } from '../../../state/ArenaTypes';
import {
  GameEventSynthesizer,
  GameEventItem
} from '../../common/events';

/**
 * Bid Whist Game Event Synthesizer.
 * Provides extensible foundation for Bid Whist domain events
 * (e.g. Boston, Trump declared, Contract made/set).
 */
export class BidWhistEventSynthesizer extends GameEventSynthesizer {
  public readonly gameType = 'BID_WHIST';

  public override synthesize(
    _currentState: ArenaGameState,
    _previousState?: ArenaGameState | null
  ): GameEventItem[] {
    return [];
  }
}
